import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { EActionType } from 'components/activity/enums';
import { notificationsApi } from 'components/notifications/notificationsApi';
import { userApi } from 'components/user/userApi';
import logger from 'lib/logger';
import { useAuth } from 'lib/useAuth';

export function useResendReceipt(orderId: number) {
    const { user } = useAuth();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(false);
    const [sent, setSent] = React.useState(false);

    const send = React.useCallback(
        async (email: string) => {
            if (!user?.id) {
                return;
            }
            setLoading(true);
            try {
                const list = await userApi.getActivityHistory(user.id);
                const actionId = list.items.find(
                    action =>
                        (action.type === EActionType.ORDER_USER_BILLED ||
                            action.type === EActionType.ORDER_COMPLETED) &&
                        action.metadata.order &&
                        action.metadata.order.id === orderId
                )?._id;
                if (!actionId) {
                    enqueueSnackbar(t('GENERAL_ERROR_PROCESSING_REQUEST'), { variant: 'error' });
                    return;
                }
                await notificationsApi.resendReceipt({ userEmail: email, actionId });
                setSent(true);
            } catch (e) {
                logger.error(e);
                enqueueSnackbar(t('GENERAL_ERROR_PROCESSING_REQUEST'), { variant: 'error' });
            } finally {
                setLoading(false);
            }
        },
        [enqueueSnackbar, orderId, t, user?.id]
    );

    return { send, loading, sent };
}
